export const coversheetKarthik = {
  dob: "",
  rate: {
    max: 1200000,
    min: 1000000,
    period: "Hourly",
    currency: "",
  },
  visa: "",
  email: "karthik@talairo.com",
  title: "Chief Digital Transformation Officer",
  location: "San Francisco, California",
  last_name: "Viswanathan",
  portfolio: "",
  first_name: "Karthik",
  other_info: {
    interests: "",
    activities: "",
    volunteer_work: "",
  },
  middle_name: "",
  job_location: "Dallas, TX",
  linkedin_url: "www.linkedin.com/karthikvish",
  phone_number: "",
  candidate_bio:
    "The candidate, Matthew Duda, presents a strong match for the Senior Full Stack Developer role at CarParts.com, with 11 years of relevant experience in full stack development, proficiency in ReactJS, RESTful APIs, and cloud services. His recent experience and technical skills align well with the job requirements, although he lacks specific management experience as an individual contributor. Overall, he is a suitable candidate for the position, with slight gaps in preferred company experience..",
  inferred_rate: {
    max: 1200000,
    min: 1000000,
    period: "yearly",
    currency: "USD",
  },
  candidate_name: "Karthik Viswanathan",
  inferred_title: "Senior Mobile Application Developer",
  company_profile: "Mid-Sized",
  seniority_level: "Executive",
  key_achievements: [
    "Successfully led the development of a comprehensive cryptocurrency trading mobile app for CoinFlex, integrating real-time data visualization and seamless third-party API integrations.",
    "Designed and developed two mobile applications for LOXE that enhanced hotel guest experiences, including features like mobile keys and online check-in.",
    "Created a full-featured React Native mobile app from scratch for ExpertSession, implementing a custom interface module for AWS Chime SDK for robust video conferencing.",
  ],
  willing_to_relocate: "",
  professional_affliations: [
    "Member of various professional software development communities, contributing to discussions on best practices in mobile app development.",
    "Active participant in tech meetups and conferences focused on React Native and mobile technologies.",
  ],
  occupational_classification: "Development",

  dei: true,
  industry: [{ content: "Technology", id: "" }],
  education: "",
  languages: [],
  certificates: [],
  govt_security_clearance: true,
  porche: null,
  manager_name: null,
  department: null,
  employment_period: null,
  employment_type: null,
  tax_term: null,
  emplopyer_name: null,
  emplopyer_phone: null,
  emplopyer_email: null,
  emplopyer_contact_name: null,
  hour_rate: null,
  contract_hour_rate: null,
  employee_hour_rate: null,
  visa_type: null,
  visa_stamped: null,
  H1B_holder_company_name: null,
  visa_valid_from: null,
  visa_valid_to: null,
  qualifications: [
    {
      gpa: "NA",
      name: "Master of Business Administration, Finance and Marketing",
      result: "Passed",
      school: "ISIMA University",
      achieved: "2002",
      end_date: "2009 - 2011",
      start_date: "",
    },
    {
      gpa: "NA",
      name: "Bachelor of Engineering, Information Engineering with Honors",
      result: "Passed",
      school: "ISIMA University",
      achieved: "2002",
      end_date: "1999 - 2002",
      start_date: "",
    },
  ],
  certifications: [],
  licenses: [],
  job_history: [
    {
      job_title: "Chief Technology and Digital Officer (Interim)",
      company: "TalAiro.AI",
      start_date: "Jan 2024",
      end_date: "Present",
      accomplishments_summary:
        "Leading the conceptualization and building of an AI powered talent matching platform aimed at simplifying the hiring process. Spearheading product, engineering, design, and go-to-market strategies globally with a goal of scaling to 10M users.",
      accomplishments: [
        "Currently leading the conceptualization and building of an AI powered talent matching platform that aims to make the process of hiring good talent quicker, simpler and more effective for organizations",
        "Spearheading product, engineering, design and go-to-market strategies globally to deliver an intuitive experience for both candidates and employers; with a goal of scaling to 10M users.",
      ],
    },
    {
      job_title: "Chief Digital Product Officer",
      company: "Optum (UnitedHealth Group)",
      start_date: "Sept 2022",
      end_date: "Feb 2024",
      accomplishments_summary:
        "Delivered $15B in business growth, increased active users by 16% YoY, improved CSAT by 14%, and achieved a +65 point increase in NPS. Unified digital technology roadmap and exceeded cost efficiency targets of $100M through AI-powered solutions.",
      accomplishments: [
        "Delivered $15B in business growth and revamped consumer and B2B digital experiences that increased active users annually by 16% YoY, CSAT by 14% and Optum.com NPS by +65 points",
        "Unified a digital technology roadmap across the enterprise to replatform the legacy stack and drive efficiencies (+18% ROI) by aligning investments to value based outcomes across pharmacy, patient services, claims/reimbursement management, provider lookup and benefit eligibility.",
        "Exceeded cost efficiency targets (100M) for both years via Gen AI powered autonomous conversational chatbots, decommissioning 600 websites + 82 apps and increasing self- service adoption via personalization",
        "Implemented robust disaster recovery and business continuity plans, ensuring 99.99% uptime and minimizing the impact of system outages during peak volumes.",
        "Led a global team of 80+ scrum teams of talented senior product leaders, engineers, CX/UX designers, researchers, accessibility experts, data analysts and B2B/B2C e-comm managers",
      ],
    },
    {
      job_title: "Vice President, Digital Product, Engineering and Experiences",
      company: "AT&T",
      start_date: "Dec 2018",
      end_date: "Sept 2022",
      accomplishments_summary:
        "Drove $4B in cost savings through digital transformation, redefined consumer experiences, and built a global team of 1500+. Implemented cloud migration and cybersecurity strategies that improved operational efficiency.",
      accomplishments: [
        "Drove $4B worth of cost savings via digital transformation and omni- channel distribution strategies for both AT&T consumer/small-business and 3rd party ecosystems.",
        "Redefined the consumer experiences by developing AI-driven personalization/Next best action, curbside pickup for stores, AI conversational chatbots and onboarding experiences that increased revenue from $8B to $35B",
        "Transformed and scaled tech products by implementing a comprehensive cloud migration strategy, deployment of a robust cybersecurity framework that resulted in a 20% reduction in IT operating costs, improved response times by 40% and scaling to handle 633M service transactions and 1.7B interactions annually",
        "Built a 1500+ high performing global team across multiple disciplines product management, engineering, content, experience design, ad-monetization, and compliance and accessibility",
      ],
    },
    {
      job_title: "Vice President, Performance Marketing and Product",
      company: "Macys",
      start_date: "Nov 2017",
      end_date: "Dec 2018",
      accomplishments_summary:
        "Responsible for all aspects of performance marketing, driving $2.5B+ in online sales, and increasing marketing ROI by 22%. Improved online conversion and orchestrated campaigns across multiple channels.",
      accomplishments: [
        "Responsible for all aspects of Macys Performance Marketing (SEM, SEO, Content Syndication and Paid Social) including strategy, operations, product, technology and analytics that drove $2.5B+ in online sales (38% of Macys.com sales) and increased reach by ~1.2M in-store.",
        "Increased marketing ROI (+22%) by improving online conversion, faster access to product information, improved search indexing, faster page load speeds and orchestrated campaigns across marketing channels.",
      ],
    },
    {
      job_title: "Director, Paid Ads",
      company: "Macys",
      start_date: "Apr 2014",
      end_date: "Nov 2017",
      accomplishments_summary:
        "Grew the search program from $600M to over $1.6B in online sales.Developed an adtech bidding algorithm that improved ROI by 22% YoY, managing a global advertising team of 30.",
      accomplishments: [
        "Grew the search program from a business unit with $600M in online sales to over $1.6B in online sales",
        "Pioneered an innovative adtech bidding algorithm that guided media budget allocation that drove significant ROI growth (+22% YoY). Scope included responsibility over a global advertising and media team of 30 people.",
      ],
    },
    {
      job_title: "Senior Manager, Omni-Channel Marketing Technology",
      company: "Macys",
      start_date: "July 2012",
      end_date: "Apr 2014",
      accomplishments_summary:
        "Re-engineered the omni-channel customer view, resulting in a $110M lift in Email/SMS campaigns. Modernized marketing platforms to unify data and insights.",
      accomplishments: [
        "Re-engineered the omni-channel customer view, for Macys e-comm and stores, that enriched audience segmentation and LTV calculation to guide growth strategies, experimentation and media mix modeling.",
        "Delivered a $110M lift in Email/SMS campaigns by modernizing the marketing platforms across channels to unify data, insights and by enabling automated lifecycle management across macys.com, stores and apps.",
      ],
    },
    {
      job_title: "Product Manager, E-commerce",
      company: "Evine Live (Formerly ShopNBC) ",
      start_date: "Jul 2006",
      end_date: "Jul 2012",
      accomplishments_summary:
        "Increased e-commerce penetration from 7% to 42% by re-platforming the e-commerce stack. Implemented a data strategy that improved traffic and conversion metrics.",
      accomplishments: [
        "Increased e-commerce penetration from a 7% penetration to 42% by re-platforming the e-commerce stack that included merchandising, pricing and offer management products and strategies.",
        "Implemented data strategy across the organization that helped track omni-channel customer interactions and increased funnel metrics such as traffic, conversion (+37%) and ROI.",
        "Oversaw technology stack for ShopNBC Distribution centers to manage order fulfillment, inventory tracking/mgmt",
        "Managed the design, implementation, and optimization of the companys ecommerce IT infrastructure, including servers, storage, networking, and end-user computing.",
      ],
    },
  ],
  reference_name: "",
  reference_phone: "",
  interview_details: "",
};
